import React from 'react'

const Contact = (props) => (
    <section id="contact">
        <div className="inner">
            <section>
                <form method="post" action="https://formspree.io/geral@ahbusiness.com">
                    <div className="field half first">
                        <label htmlFor="name">Nome</label>
                        <input type="text" name="name" id="name" />
                    </div>
                    <div className="field half">
                        <label htmlFor="email">E-mail</label>
                        <input type="text" name="_replyto" id="email" />
                    </div>
                    <div className="field">
                        <label htmlFor="message">Mensagem</label>
                        <textarea name="message" id="message" rows="6"></textarea>
                    </div>
                    <ul className="actions">
                        <li><input type="submit" value="Enviar Mensagem" className="special" /></li>
                        <li><input type="reset" value="Limpar" /></li>
                    </ul>
                </form>
            </section>
            <section className="split">
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-envelope"></span>
                        <header><h7>E-mail</h7></header>
                        <a href="mail:to">geral@ahbusiness.com</a>
                    </div>
                </section>
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-phone"></span>
                        <header><h7>Telefone</h7></header>
                        <span> (+351) 222 085 594</span>
                    </div>
                </section>
                <section>
                    <div className="contact-method">
                        <span className="icon alt fa-home"></span>
                        <header><h7>Endereço</h7></header>
                        <span>Rua Dom João I,
                        256 Matosinhos,
                        Portugal</span>
                    </div>
                </section>
            </section>
        </div>
    </section>
)

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact.js